common.View.create('canvas.blocks.custom.headerWithImage.Block', {
    onDOMLoad() {
        this.initScrollDown();
    },

    initScrollDown() {
        this.element.find('.scroll-down').on('click', () => {
            let header = $('header');
            let el = this.element;
            let bottom = el.position().top + el.outerHeight(true) - header.outerHeight(true);

            window.scrollTo({
                top: bottom,
                behavior: 'smooth',
            });
        });
    },
});
